import { Injectable } from '@angular/core';
import {
  ApproveAccessRequestCommand,
  RejectAccessRequestCommand,
  RequestAccessCommand,
  UpdateUserCommand,
  UserDetailDto,
} from '@common';
import { plainToInstance } from 'class-transformer';
import { map, Observable } from 'rxjs';
import { ApiWrapperService } from './api-wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor (private readonly api: ApiWrapperService){}

  getUsers(): Observable<UserDetailDto[]> {
    return this.api.get('Main', '/user', {}).pipe(
      map((users: UserDetailDto[]) =>
        users.map(u => plainToInstance(UserDetailDto, u))
      )
    );
  }

  getUserByLogin(login: string): Observable<UserDetailDto> {
    return this.api.get('Main', '/user/by-login', {
        queryStringParameters: {
          login,
        },
      })
    .pipe(map(v => plainToInstance(UserDetailDto, v)));
  }

  updateUser(updateUserCommand: UpdateUserCommand): Observable<UserDetailDto> {
    return this.api.put('Main', '/user', {
        body: updateUserCommand,
      })
    .pipe(map(v => plainToInstance(UserDetailDto, v)));
  }

  requestAccess(requestAccessCommand: RequestAccessCommand): Observable<void> {
    return this.api.post('Main', '/user/request-access', {
        body: requestAccessCommand,
      });
  }

  approveAccessRequest(
    approveAccessRequestCommand: ApproveAccessRequestCommand
  ): Observable<void> {
    return this.api.post('Main', '/user/approve-access-request', {
        body: approveAccessRequestCommand,
      });
  }

  rejectAccessRequest(
    rejectAccessRequestCommand: RejectAccessRequestCommand
  ): Observable<void> {
    return this.api.post('Main', '/user/reject-access-request', {
        body: rejectAccessRequestCommand,
      });
  }
}
